import type { ManagerGetCampaignModel } from 'entities/campaign';

export function hasCampaignValidIntegrations(campaign: ManagerGetCampaignModel): boolean {
  if (campaign.type === 'appt') {
    return true;
  }

  return !!(campaign.campaignIntegrations || []).filter(({ isActive }) => isActive).length;
}

export function hasCampaignValidSchedule(schedule: ManagerGetCampaignModel['schedule']): boolean {
  if (!schedule) {
    return true;
  }

  return Object.values(schedule).some((weekDay) => weekDay.isSelected);
}

export function hasCampaignValidSimplyBook(campaign: ManagerGetCampaignModel): boolean {
  if (campaign.type !== 'appt') {
    return true;
  }

  return !!campaign.simplybookUrl;
}

export function isActiveApproveButton(campaign: ManagerGetCampaignModel) {
  return (
    hasCampaignValidSchedule(campaign.schedule) &&
    hasCampaignValidIntegrations(campaign) &&
    hasCampaignValidSimplyBook(campaign)
  );
}
